/* screens/auth/NewPassword.jsx — Новый пароль (S12, /reset-password?uid&token).
   Фикс №28: после успеха navigate('/signin?password_reset=done', {replace}) — кнопка «Назад»
   браузера не возвращает на форму с использованным токеном (SignIn покажет баннер успеха).
   Бэк: невалидный/устаревший токен → 400 code='invalid_token' (detail → topError); слабый
   пароль → 400 (detail). Данные через authReal (adapters/auth.js: password→new_password). */

import React from 'react';
import { Button } from '../../components/ui/Button.jsx';
import { Field, PasswordInput, StrengthMeter } from '../../components/ui/Field.jsx';
import { Icon } from '../../components/ui/Icon.jsx';
import { ScreenHeader } from '../../components/ui/Metric.jsx';
import { authReal } from '../../lib/api/index.js';
import { RR } from '../../lib/router.jsx';

  const { useState } = React;
  const { useNavigate, useSearchParams, Link } = RR;

  function NewPassword() {
    const navigate = useNavigate();
    const [sp] = useSearchParams();
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [errors, setErrors] = useState({});
    const [topError, setTopError] = useState(null);
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
      e.preventDefault();
      const errs = {};
      if (password.length < 8) errs.password = 'Минимум 8 символов.';
      if (confirm !== password) errs.confirm = 'Пароли не совпадают.';
      setErrors(errs); setTopError(null);
      if (Object.keys(errs).length) return;

      setLoading(true);
      try {
        await authReal.confirmPasswordReset({ uid: sp.get('uid'), token: sp.get('token'), password });
        navigate('/signin?password_reset=done', { replace: true });
      } catch (err) {
        setTopError(err.message || 'Не удалось сохранить пароль.');
        setLoading(false);
      }
    };

    return (
      <form className="auth-form stack stack-16" onSubmit={submit} noValidate>
        <ScreenHeader eyebrow="Сброс пароля" title="Новый пароль" subtitle="Придумайте пароль, который не используете в других сервисах." />

        {topError && (
          <div className="callout callout--bad" role="alert">
            <Icon name="alert-circle" size={16} /><span>{topError}</span>
          </div>
        )}

        <div className="stack stack-12">
          <Field label="Новый пароль" htmlFor="np-pass" error={errors.password}
            hint={!errors.password ? 'Минимум 8 символов' : undefined}>
            <PasswordInput id="np-pass" value={password} autoComplete="new-password" invalid={errors.password ? true : undefined}
              placeholder="Новый пароль" onChange={(e) => setPassword(e.target.value)} />
          </Field>
          <StrengthMeter value={password} />
          <Field label="Повторите пароль" htmlFor="np-confirm" error={errors.confirm}>
            <PasswordInput id="np-confirm" value={confirm} autoComplete="new-password" invalid={errors.confirm ? true : undefined}
              placeholder="Ещё раз" onChange={(e) => setConfirm(e.target.value)} />
          </Field>
        </div>

        <Button type="submit" variant="primary" size="lg" loading={loading} className="full">Сохранить пароль</Button>

        <p className="auth-form__alt t-body text-dim">
          <Link to="/signin" className="link">Отмена</Link>
        </p>
      </form>
    );
  }

export { NewPassword };
